import { create } from 'zustand'

type NotificationSocketState = {
  connectionLost: boolean
  setConnectionLost: (lost: boolean) => void
}

export const useNotificationSocketStore = create<NotificationSocketState>((set) => ({
  connectionLost: false,
  setConnectionLost: (lost) => set({ connectionLost: lost }),
}))

/** Vitest only — reset module state between tests. */
export function resetNotificationSocketStoreForTests(): void {
  useNotificationSocketStore.setState({ connectionLost: false })
}
